import { IOfferSpendByOfferScopeViewLang } from '../../../types/lang'
import { EOfferSpendByOfferScopeView } from '../../../types'

export const offerSpendByOfferScopeViewLang: IOfferSpendByOfferScopeViewLang = {
	offer_spend_by_offer_scope_view: {
		[EOfferSpendByOfferScopeView.Day]: 'день',
		[EOfferSpendByOfferScopeView.Month]: 'місяць'
	}
}